/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Menu Card',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M16.3291 18.1484C16.6602 18.1488 16.9287 18.4179 16.9287 18.749C16.9284 19.0799 16.66 19.3483 16.3291 19.3486H7.66992C7.3389 19.3484 7.07059 19.08 7.07031 18.749C7.07031 18.4178 7.33873 18.1486 7.66992 18.1484H16.3291Z"
            fill="currentColor"
          />
          <path
            d="M14.9414 15.4492C15.2727 15.4493 15.542 15.7175 15.542 16.0488C15.5419 16.3801 15.2726 16.6483 14.9414 16.6484H9.05566C8.72444 16.6483 8.45612 16.3801 8.45605 16.0488C8.45605 15.7175 8.7244 15.4493 9.05566 15.4492H14.9414Z"
            fill="currentColor"
          />
          <path
            d="M15.7822 12.75C16.1135 12.7501 16.3828 13.0183 16.3828 13.3496C16.3827 13.6808 16.1134 13.9491 15.7822 13.9492H8.21582C7.88469 13.949 7.61628 13.6808 7.61621 13.3496C7.61621 13.0184 7.88465 12.7502 8.21582 12.75H15.7822Z"
            fill="currentColor"
          />
          <path
            d="M14.1533 10.0508C14.4846 10.0509 14.7529 10.3191 14.7529 10.6504C14.7529 10.9816 14.4845 11.2498 14.1533 11.25H9.8457C9.51437 11.25 9.24616 10.9817 9.24609 10.6504C9.24609 10.319 9.51433 10.0508 9.8457 10.0508H14.1533Z"
            fill="currentColor"
          />
          <path
            d="M14.1533 7.35156C14.4846 7.35173 14.7529 7.6199 14.7529 7.95117C14.7529 8.28238 14.4845 8.55062 14.1533 8.55078H9.8457C9.51437 8.55078 9.24616 8.28249 9.24609 7.95117C9.24609 7.6198 9.51433 7.35156 9.8457 7.35156H14.1533Z"
            fill="currentColor"
          />
          <path
            d="M15.4541 4.65234C15.7854 4.65238 16.0547 4.9206 16.0547 5.25195C16.0546 5.58325 15.7854 5.85153 15.4541 5.85156H8.54297C8.21174 5.85144 7.94343 5.58319 7.94336 5.25195C7.94336 4.92066 8.2117 4.65247 8.54297 4.65234H15.4541Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 0.400391C20.8835 0.400391 21.5994 1.11652 21.5996 2V22C21.5996 22.8837 20.8837 23.5996 20 23.5996H4C3.11652 23.5994 2.40039 22.8835 2.40039 22V2C2.4006 1.11665 3.11665 0.400601 4 0.400391H20ZM4 1.59961C3.7794 1.59982 3.59982 1.7794 3.59961 2V22C3.59961 22.2208 3.77927 22.4002 4 22.4004H20C20.2209 22.4004 20.4004 22.2209 20.4004 22V2C20.4002 1.77927 20.2208 1.59961 20 1.59961H4Z"
            fill="currentColor"
          />
        </>
      ),
    },
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            d="M31.499 36.5C31.8439 36.5002 32.1239 36.7801 32.124 37.125C32.1238 37.4698 31.8438 37.7498 31.499 37.75H16.4961C16.1513 37.7498 15.8713 37.4698 15.8711 37.125C15.8712 36.7801 16.1512 36.5002 16.4961 36.5H31.499Z"
            fill="currentColor"
          />
          <path
            d="M30.0576 31.25C30.4027 31.2503 30.6836 31.5298 30.6836 31.875C30.6835 32.2201 30.4027 32.4997 30.0576 32.5H17.9365C17.5914 32.4998 17.3117 32.2202 17.3115 31.875C17.3115 31.5297 17.5913 31.2502 17.9365 31.25H30.0576Z"
            fill="currentColor"
          />
          <path
            d="M30.9336 26C31.2788 26.0003 31.5596 26.2798 31.5596 26.625C31.5594 26.9701 31.2787 27.2497 30.9336 27.25H17.0605C16.7156 27.2495 16.4357 26.97 16.4355 26.625C16.4355 26.2799 16.7155 26.0005 17.0605 26H30.9336Z"
            fill="currentColor"
          />
          <path
            d="M29.2354 20.75C29.5807 20.7501 29.8604 21.0296 29.8604 21.375C29.8602 21.7202 29.5806 21.9999 29.2354 22H18.7598C18.4145 21.9999 18.1349 21.7203 18.1348 21.375C18.1348 21.0296 18.4144 20.7501 18.7598 20.75H29.2354Z"
            fill="currentColor"
          />
          <path
            d="M29.2354 15.5C29.5807 15.5001 29.8604 15.7796 29.8604 16.125C29.8602 16.4702 29.5806 16.7499 29.2354 16.75H18.7598C18.4145 16.7499 18.1349 16.4703 18.1348 16.125C18.1348 15.7796 18.4144 15.5001 18.7598 15.5H29.2354Z"
            fill="currentColor"
          />
          <path
            d="M30.5918 10.25C30.9371 10.2501 31.2178 10.5297 31.2178 10.875C31.2176 11.2202 30.937 11.4999 30.5918 11.5H17.4023C17.0571 11.4999 16.7775 11.2202 16.7773 10.875C16.7773 10.5296 17.057 10.2501 17.4023 10.25H30.5918Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40 1.375C41.4497 1.375 42.625 2.55025 42.625 4V44C42.6249 45.4496 41.4497 46.625 40 46.625H8C6.55033 46.625 5.37513 45.4496 5.375 44V4C5.375 2.55025 6.55025 1.375 8 1.375H40ZM8 2.625C7.24061 2.625 6.625 3.24061 6.625 4V44C6.62513 44.7593 7.24069 45.375 8 45.375H40C40.7593 45.375 41.3749 44.7593 41.375 44V4C41.375 3.24061 40.7594 2.625 40 2.625H8Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
